import React, { Fragment, memo, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Grid, IconButton, TextareaAutosize, Tooltip } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DoneIcon from '@material-ui/icons/Done';
import CancelIcon from '@material-ui/icons/Cancel';
import { Label } from 'reactstrap';
import { v4 as uuid } from 'uuid';
import PropTypes from 'prop-types';
import { getDateAndDayUTC } from '../../../shared/utils/smartutils';

const MenuItemsMaintenance = (props) => {
  const {
    updateMenuItems,
    t,
    updateLastSelectedDate,
    menuItemsWrapper,
    toggleSaveMealModal,
    editField,
    meal,
    toggleEditField,
    setMeal,
  } = props;

  const [selectedMealEdit, setSelectedMealEdit] = useState({});

  const onMealChange = (evt) => {
    const updatedMeal = { ...meal, name: evt.target.value };
    setSelectedMealEdit(updatedMeal);
  };

  const editMeal = (item) => {
    setSelectedMealEdit(item);
    toggleEditField(item);
  };

  const persistMealName = () => {
    if (selectedMealEdit.name !== meal.name) {
      setMeal(selectedMealEdit);
      toggleSaveMealModal();
    } else {
      toggleEditField();
    }
  };

  const onItemChange = (e) => {
    const itemIdentifier = e.target.name.split('_');
    const dateInMilli = itemIdentifier[0];
    const mealId = itemIdentifier[1];
    const columnIndex = itemIdentifier[2];
    const updatedMenuItemsWrapper = { ...menuItemsWrapper };
    const updatedMenuItems = updatedMenuItemsWrapper.menuColumns[
      columnIndex
    ].menuItems.map((element) => {
      const updatedElement = { ...element };
      if (
        element.dateInMilli.toString() === dateInMilli.toString() &&
        element.mealId.toString() === mealId.toString()
      ) {
        updatedElement.menuItemDescription = e.target.value;
      }
      return updatedElement;
    });
    updatedMenuItemsWrapper.menuColumns[columnIndex].menuItems =
      updatedMenuItems;
    updateMenuItems(updatedMenuItemsWrapper, true);
  };

  const mealColumnContent = menuItemsWrapper.meals.map((item) => (
    <Grid
      className="meal-box justify-content-flex-end"
      container
      item
      xs={12}
      spacing={0}
      key={item.id}
    >
      {editField.status && editField.id === item.id ? (
        <div className="d-flex flex-column pl-3">
          <div className="form__form-group-field">
            <input value={selectedMealEdit.name} onChange={onMealChange} />
          </div>
          <div className="form__form-group-field justify-content-center pt-2">
            <Tooltip id="save" title={t('general.save')}>
              <IconButton onClick={persistMealName}>
                <DoneIcon />
              </IconButton>
            </Tooltip>
            <Tooltip id="cancel" title={t('general.cancel')}>
              <IconButton
                onClick={(evt) => {
                  evt.persist();
                  toggleEditField();
                }}
              >
                <CancelIcon />
              </IconButton>
            </Tooltip>
          </div>
        </div>
      ) : (
        <div className="d-flex align-items-center">
          <div>
            <Label className="form__form-group-label p-2">{item.name}</Label>
          </div>
          <Tooltip id="edit" title={t('general.edit')}>
            <IconButton onClick={() => editMeal(item)}>
              <EditIcon />
            </IconButton>
          </Tooltip>
        </div>
      )}
    </Grid>
  ));

  const columnsData = menuItemsWrapper.menuColumns.map((headerItem) => ({
    ...headerItem,
  }));

  const menuItemsColumnsContent = menuItemsWrapper.menuColumns.map(
    (headerItem) => (
      <Grid
        container
        item
        xs
        spacing={0}
        className="items-header-box"
        key={uuid()}
      >
        <Label className="form__form-group-label header-label">
          {getDateAndDayUTC(headerItem.dateInMilli)}
        </Label>
      </Grid>
    )
  );

  function generateMenuItemsColumns(itemColumns, index) {
    const itemsColumnsContent = itemColumns.map((itemColumn) => (
      <Grid
        container
        item
        xs={12}
        spacing={0}
        key={`${itemColumn.dateInMilli}_${itemColumn.mealId}_${index}`}
      >
        <TextareaAutosize
          className="item-menu-description overflow-auto"
          rows={2}
          onChange={onItemChange}
          maxLength={500}
          key={`${itemColumn.dateInMilli}_${itemColumn.mealId}`}
          name={`${itemColumn.dateInMilli}_${itemColumn.mealId}_${index}`}
          defaultValue={itemColumn.menuItemDescription}
        />
      </Grid>
    ));
    updateLastSelectedDate(itemColumns[3].dateInMilli);
    return itemsColumnsContent;
  }

  return (
    <Fragment>
      <Grid container spacing={0} className="menu-items">
        <Grid container item xs={2} spacing={0} className="meal-header-box">
          <Label className="form__form-group-label">{t('general.meals')}</Label>
        </Grid>
        {menuItemsColumnsContent}
      </Grid>
      <Grid container spacing={0}>
        <Grid container item xs={2} spacing={0} className="menu-items">
          {mealColumnContent}
        </Grid>
        {columnsData.map((item, index) => (
          <Grid
            container
            item
            xs
            spacing={0}
            key={`${item.dateInMilli}-${index + index}`}
          >
            {generateMenuItemsColumns(item.menuItems, index)}
          </Grid>
        ))}
      </Grid>
    </Fragment>
  );
};

MenuItemsMaintenance.propTypes = {
  updateMenuItems: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  menuItemsWrapper: PropTypes.shape(PropTypes.shape),
  updateLastSelectedDate: PropTypes.func.isRequired,
  toggleSaveMealModal: PropTypes.func.isRequired,
  toggleEditField: PropTypes.func.isRequired,
  editField: PropTypes.shape(PropTypes.shape).isRequired,
  meal: PropTypes.shape(PropTypes.shape).isRequired,
  setMeal: PropTypes.func.isRequired,
};

MenuItemsMaintenance.defaultProps = {
  menuItemsWrapper: {
    meals: [],
    menuColumns: [],
  },
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(memo(MenuItemsMaintenance))
);
